import recalcData from "../../../common/model/logic/recalcData.js"
import load from "./load.js"
import merge from "./merge.js"

const reCalc = async (data, operation, prevData) => {   
    let result = null
    let config = recalcData[operation.reCalcData]

    const { operations } = config
    let opState = {}

    for (const operation of operations) {

        switch (operation.type) {
            case 'loadEntities':
                result =await load(data, operation, opState)
                break;
            case 'merge':
                result =await merge(data, operation, opState)
                break;
            default:
                break;
        }

        //console.log('[i] opstate: ', opState)
    }



    if (result) return result
    //ALWAYS RETURN AT THE END OF ALL IF STATEMENTS
    return { ...data };
}

export default reCalc